/**
 * Delivery page — static factual data.
 *
 * ZIPs and zone definitions are public, factual info about ZenZest's NY-licensed
 * delivery service. All editorial copy is original.
 */
export const ZONES = [
    {
        id: "local",
        label: "Tier 1 · Queens & Western Nassau",
        title: "Local Zone",
        min: "$100",
        fee: "Free",
        eta: "60–90 min",
        zipCount: 26,
        sample: "New Hyde Park (HQ) · Bellerose · Floral Park · Glen Oaks · Queens Village · Great Neck…",
        zips: [
            "11040", "11001", "11002", "11003", "11004", "11005", "11010", "11020",
            "11021", "11023", "11030", "11042", "11354", "11355", "11357", "11358",
            "11361", "11362", "11363", "11364", "11365", "11366", "11426", "11427",
            "11428", "11429",
        ],
    },
    {
        id: "extended",
        label: "Tier 2 · Central & southern Nassau Long Island",
        title: "Nassau Extended",
        min: "$100",
        fee: "Free",
        eta: "90–150 min",
        zipCount: 28,
        sample: "Mineola · Albertson · Roslyn · Garden City · Hempstead · Westbury…",
        zips: [
            "11501", "11507", "11514", "11530", "11531", "11550", "11552", "11553",
            "11554", "11556", "11557", "11558", "11559", "11560", "11561", "11563",
            "11570", "11572", "11575", "11576", "11577", "11579", "11580", "11581",
            "11596", "11710", "11791", "11793",
        ],
    },
    {
        id: "long-reach",
        label: "Tier 3 · Eastern Nassau & Western Suffolk",
        title: "Long Reach",
        min: "$100",
        fee: "Free",
        eta: "2–3 hrs",
        zipCount: 15,
        sample: "Bethpage · Hicksville · Plainview · Syosset · Melville · Huntington Station…",
        zips: [
            "11714", "11756", "11758", "11762", "11783", "11784", "11801", "11803",
            "11804", "11731", "11743", "11746", "11747", "11749", "11788",
        ],
    },
];

export const SI_ZONE = {
    title: "All of Staten Island",
    min: "$100",
    fee: "Free",
    eta: "60–90 min",
    zipCount: 13,
    zips: [
        "10301", "10302", "10303", "10304", "10305", "10306", "10307", "10308",
        "10309", "10310", "10311", "10312", "10314",
    ],
    sample:
        "Mariners Harbor (HQ) · Port Richmond · West Brighton · St. George · New Brighton · Tompkinsville · Stapleton · Clifton · Castleton Corners · Sunnyside · Dongan Hills · Grasmere · Arrochar · South Beach · New Dorp · Oakwood · Midland Beach · Bulls Head · New Springville · Heartland Village · Willowbrook · Travis · Bloomfield · Chelsea · Annadale · Eltingville · Great Kills · Huguenot · Prince's Bay · Charleston · Tottenville",
};

export const RULES = [
    "You must be 21+ with a valid government photo ID. The order holder is the one who has to be at the door — no exceptions.",
    "Delivery is to a private residential address only. Hotels, offices, dorms, federal property (including post offices) are not eligible.",
    "Single-transaction limits per NY law: three ounces of cannabis flower or 24 grams of concentrate.",
    "Payment is cash on delivery (exact change appreciated), debit, in-store ATM, or digital bank transfer at checkout. Credit cards aren't permitted under current federal banking rules.",
    "Cannabis cannot cross state lines — federal law. That includes New Jersey and Connecticut.",
    "Tips are never required, never auto-added, and always appreciated in cash at the door.",
];

export const FAQ = [
    {
        q: "Where does ZenZest deliver?",
        a: "Same-day from two NY-licensed flagships. The Queens store covers three tiers — Local Zone (Queens + Western Nassau, 60–90 min), Nassau Extended (Central & Southern Nassau, 90–150 min), and Long Reach (Eastern Nassau & Western Suffolk, 2–3 hrs). The Staten Island store covers every active SI ZIP code (10301–10314) in 60–90 minutes. $100 minimum everywhere; delivery is free.",
    },
    {
        q: "How fast is same-day delivery?",
        a: "In the Local Zone and across all of Staten Island, most orders land within 60–90 minutes. Nassau Extended runs 90–150 minutes. Long Reach is 2–3 hours depending on time of day and route. You'll get a live ETA text once your order is dispatched.",
    },
    {
        q: "How much does delivery cost?",
        a: "Free across every zone. One flat $100 order minimum — no surge fees, no add-ons, no surprises at checkout.",
    },
    {
        q: "What payment do drivers accept?",
        a: "Cash on delivery (exact change appreciated), debit, in-store ATM, or digital bank transfer at checkout. Federal banking restrictions still bar dispensaries from running credit cards.",
    },
    {
        q: "Do I have to be home for delivery?",
        a: "Yes. The legal account holder has to be there in person with their matching government-issued 21+ ID. We can't leave cannabis at the door, with a doorman, a roommate, or a household member who didn't place the order.",
    },
    {
        q: "Can I have cannabis delivered to a hotel or office?",
        a: "No. New York state delivery rules require a private residential address. Hotels, offices, dorms, federal buildings, and commercial addresses aren't eligible.",
    },
    {
        q: "Is cannabis delivery legal in Long Island?",
        a: "Yes — when delivered by a NY-licensed adult-use dispensary. Most Nassau and Suffolk towns opted out of cannabis retail under the MRTA, so licensed Queens dispensaries are the lawful supply for the entire western LI corridor. Verify any operator at the NY OCM dispensary verification tool.",
    },
    {
        q: "How late can I order?",
        a: "Same-day cutoffs depend on day and zone — generally about 90 minutes before store close. The Queens store stays open until midnight most nights (and 2 AM Wed–Fri), so genuinely late delivery is on the table. Cutoffs display at checkout once you enter your address.",
    },
];
